import script from "./cnt-error_code.vue?vue&type=script&lang=ts&setup=true"
export * from "./cnt-error_code.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__